import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';
import { StripePaymentMethodCard } from '@/modules/billing/models/stripe/StripePaymentMethodCard';
import { StripePaymentMethodBillingDetails } from '@/modules/billing/models/stripe/StripePaymentMethodBillingDetails';

export class StripePaymentMethod extends BaseModel {
  public billingDetails?: StripePaymentMethodBillingDetails;
  public card?: StripePaymentMethodCard;

  constructor(model: Partial<StripePaymentMethod> = {}) {
    super();

    this.billingDetails = StripePaymentMethodBillingDetails.mapModel(model.billingDetails);
    this.card = StripePaymentMethodCard.mapModel(model.card);
  }
}
